/*! bm-client-app - v4.2.8 - 2019-09-06 - Copyright 2016 Thomson Reuters™. All rights reserved. */(function(angular){
  'use strict';

  // TODO: ADD-IN BENTO DEPENDENCY FOR BENTO-RESET DIRECTIVE
  angular.module('bmClientAppHeader', [
    'bm.component.templates',
    'ui.bootstrap',
    'bento.modern',
    'pascalprecht.translate',
    'bluemoon.components.session',
    'bluemoon.components.theme',
    'bluemoon.components.util',
    'bluemoon.help',
    'bmUser',
    'bmPermission',
    'bmPrivacyPolicy',
    'bmLinkedAccounts',
    'bmAccess'
  ]).component('bmClientAppHeader', {
    templateUrl: 'components/client-header/export/client-header.html',
    bindings: {
      preview: '@'
    },
    controller: clientAppHeader,
  }).config(['$uibTooltipProvider', function($uibTooltipProvider){
    // delay tooltips for menu hover over icons
    $uibTooltipProvider.options({
      popupDelay: 800
    });
  }]);

  clientAppHeader.$inject = [
    '$window',
    '$scope',
    '$rootScope',
    '$document',
    '$q',
    '$translate',
    'AuthenticatedSession',
    'AuthenticatedSessionData',
    'bmUser',
    'bmPermission',
    'bmTheme',
    'bmUtil',
    'bmAccess',
    'bmEnvironment',
    'bmEnvironmentConst',
    'myAccountService',
    '$uibModal',
    'LinkedAccountsService',
    'bmModal'];
  function clientAppHeader(
    $window,
    $scope,
    $rootScope,
    $document,
    $q,
    $translate,
    authenticatedSession,
    authenticatedSessionData,
    bmUser,
    bmPermission,
    theme,
    bmUtil,
    bmAccess,
    bmEnvironment,
    bmEnvironmentConst,
    myAccountService,
    $uibModal,
    LinkedAccountsService,
    bmModal){
    /*jshint validthis:true */
    var ctrl = this;
    var signOutUrl;

    // listeners
    var rmProfPhotoSelectedEvtListener;

    ctrl.$onInit = onInit;
    ctrl.$postLink = postLink;
    ctrl.$onDestroy = onDestroy;

    // Linked account stuff
    ctrl.linkedAccounts = [];
    ctrl.selectedLinkedAccount = undefined;
    ctrl.showLinkedAccountsMenu = false;
    ctrl.linkedAccountFound = false;
    ctrl.sharedProfile = {};
    ctrl.isPreviewModeEnabled = false;
    ctrl.previewModal = undefined;
    var linkedAccountSessionToken;

    ////////////////////

    function onInit() {
      ctrl.theme = theme.data;
      ctrl.user = bmUser;
      ctrl.contactId = ctrl.user.contactId;
      ctrl.clearNavActive = clearNavActive;
      ctrl.toggleNavActive = toggleNavActive;
      ctrl.closeCCVnextAlert = closeCCVnextAlert;
      ctrl.openViewProfileDialog = openViewProfileDialog;
      ctrl.signOut = signOut;
      ctrl.hasApps = hasApps;
      ctrl.isPreview = ctrl.preview === 'true';
      ctrl.openManageLinkedAccountsDialog = openManageLinkedAccountsDialog;
      ctrl.switchAccount = switchAccount;

      closeDropdowns();

      loadUser();
      checkIsPreviewMode();

      $translate('bm.client.app.userMenu.toggle').then(function(value){
        ctrl.userMenuToggle = value;
      });

      $translate('bm.client.app.helpMenu.toggle').then(function(value){
        ctrl.helpMenuToggle = value;
      });

      $translate('bm.client.app.linkedAccountMenu.toggle').then(function(value){
        ctrl.linkedAccountMenuToggle = value;
      });

      $translate('bm.client.app.appsMenu.toggle').then(function(value){
        ctrl.appsMenuToggle = value;
      });

      $translate('bm.client.app.navMenu.toggle').then(function(value){
        ctrl.navMenuToggle = value;
      });
      $rootScope.$on('bmLanguageChangeSuccess', function() {
        ctrl.searchLabel = $translate.instant('bm.client.app.helpMenu.searchLabel');
      });

      // listeners
      rmProfPhotoSelectedEvtListener = $rootScope.$on('bmProfilePhotoSelected', bmUser.save);
    }

    // CCVNext coming Soon Alert
    function setHHTCLocaleFolder() {
      var lang;
      if (bmUtil.cookie('BMLanguageCode')) {
        lang = bmUtil.cookie('BMLanguageCode');
      } else {
        lang = bmEnvironmentConst.defaultLang;
      }
      var langArr = lang.split('-');
      var HHTCFolder = langArr[1] + '-' + langArr[0];
      return HHTCFolder.toLowerCase();
    }

    bmAccess.has('ClientCenterSoon').then(function() {
      var folder = setHHTCLocaleFolder();
      var url = '/ua/help/' + folder + '/client/core/client-center-update.htm';
      $translate([
        'bm.client.app.ccvnextComingSoon',
        'bm.client.app.ccvnextMoreInfo'
      ]).then(function(value){
        if (!window.sessionStorage.getItem('ccVnextComingSoon') && !ctrl.isPreview) {
          $scope.ccVnextAlert = [{
            type: 'info',
            msg: value['bm.client.app.ccvnextComingSoon'] + ' <a href="' + url + '" target="_blank">' + value['bm.client.app.ccvnextMoreInfo'] + '</a>',
            closeable: true
          }];
        }
      });
    }).catch(function(err) {
      if (!err) {
        console.error('An error ocurred checking IAC.');
      }
    });

    function closeCCVnextAlert() {
      window.sessionStorage.setItem('ccVnextComingSoon', true);
    }

/* Start Linked Accounts Functions */
    function loadUser() {
      if(authenticatedSession.data){
        authenticatedSession.data.getBindings().then(function(data){
          ctrl.contactId = data.ApplicationConfiguration.ContactId;
          bmAccess.has('PPE-AccountSwitching').then(function(){
            loadLinkedAccounts();
          }).catch(function(error){
            console.log(error);
            ctrl.linkedAccounts = [];
            ctrl.linkedAccountFound = false;
          });
        }).catch(function(error){
          console.log(error);
          ctrl.linkedAccounts = [];
          ctrl.linkedAccountFound = false;
        });
      }
    }
    function openPreviewModeModal () {
       var modalOptions = {
          templateUrl: 'components/client-header/preview-mode-modal/preview-mode-modal.html',
          controllerAs: 'ctrl',
          backdrop: 'static',
          size: 'md',
          windowClass:'preview-modal',
          controller: function() {
            this.closeModal = function() {
              ctrl.previewModal.dismiss();
            };
          }
        };
          ctrl.previewModal = $uibModal.open(modalOptions);
    }

    function checkIsPreviewMode () {
      bmPermission.has('Platform.PreviewMode').then(function (response) {
        ctrl.isPreviewModeEnabled = response;
        if(ctrl.isPreviewModeEnabled) {
          openPreviewModeModal();
        }
      });
    }

    function loadLinkedAccounts(){
      LinkedAccountsService.getActiveOnvioLinkedAccounts().then(function(response){
          ctrl.linkedAccounts = response.data;
          setupLinkedAccounts();
      }).catch(function(error){
          console.log(error);
          ctrl.linkedAccounts = [];
          ctrl.linkedAccountFound = false;
      });

    }

    function setupLinkedAccounts() {
        var pos = 0;
        var posFound = -1;

        // setup length constraints
        for(pos = 0; pos < ctrl.linkedAccounts.length; pos++) {
            if(!ctrl.linkedAccounts[pos].displayedNickname || ctrl.linkedAccounts[pos].displayedNickname === '') {
                ctrl.linkedAccounts[pos].displayedNickname = '';
                ctrl.linkedAccounts[pos].displayedName = ctrl.linkedAccounts[pos].accountName;
            } else {
                ctrl.linkedAccounts[pos].displayedName = ctrl.linkedAccounts[pos].displayedNickname;
            }
        }

        // setup view
        if(ctrl.linkedAccounts.length > 1) {
            for(pos = 0; pos < ctrl.linkedAccounts.length; pos++) {
                if(ctrl.linkedAccounts[pos].contactId === ctrl.contactId) {
                    ctrl.linkedAccountFound = true;
                    ctrl.selectedLinkedAccount = ctrl.linkedAccounts[pos];
                    posFound = pos;
                    pos = ctrl.linkedAccounts.length;
                }
            }
            ctrl.showLinkedAccountsMenu = true;

            if(posFound >= 0) {
              ctrl.linkedAccounts.splice(posFound, 1);
            }

        } else {
            ctrl.selectedLinkedAccount = ctrl.linkedAccounts[0];
            ctrl.showLinkedAccountsMenu = false;
            ctrl.linkedAccountFound = true;
        }
    }

    function openManageLinkedAccountsDialog(){
      var modalOptions = {
        templateUrl: 'components/linked-accounts/linked-accounts-dialog.2js.html',
        controller: 'LinkedAccountsDialogCtrl as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          user: function(){
            return undefined;
          },
          sharedProfile: function(){
            return {};
          }
        }
      };

      modalOptions.resolve = {
        user: function(){
          return ctrl.user;
        },
        sharedProfile: function(){
          return ctrl.sharedProfile;
        }
      };

      openModalWithOptions(modalOptions);
    }

    function switchAccount(linkedAccountId) {
      $scope.$emit('bm-busy-loading-on');
      LinkedAccountsService.createLinkedAccountSession(linkedAccountId).then(function(response){
        if (response.data.RedirectingDomain) {
          // redirect the window to the new domain with the sso token
          var ssoUrl = response.data.RedirectingDomain;
          var routingPath = response.data.RoutingPath;
          if (routingPath) {
            // remove the first '/' if it exists
            var subPath = routingPath.startsWith('/') ? routingPath.substring(1) : routingPath;
            ssoUrl = ssoUrl + subPath;
          }
          if (ssoUrl.indexOf('#') < 0) {
             // add '#' if it does not exist
             ssoUrl = ssoUrl + '#/';
          }
          ssoUrl = ssoUrl + '?token=' + response.data.SsoTokenId;
          $window.location.href = ssoUrl;
        } else {
          // load the new session on the same domain
          linkedAccountSessionToken = response.data.LongToken;
          authenticatedSession.switchAccountWithLongToken(linkedAccountSessionToken);
        }
        $scope.$emit('bm-busy-loading-off');
      }).catch(function(error){
        console.log(error);
        $scope.$emit('bm-busy-loading-off');
      });
    }
/* End Linked Accounts Functions */

    function postLink(){
      authenticatedSessionData.getBindings().then(function(data){
        theme.loadHeader(data.ApplicationConfiguration.CompanyId).then(function(themeData){
          applyTheme(themeData);
          signOutUrl = !!themeData.data && themeData.data.logoutUrl ? themeData.data.logoutUrl : undefined;
        });
      });
    }

    function onDestroy(){
      rmProfPhotoSelectedEvtListener();
    }

    function notSupportPreviewModePopup() {
        bmModal.modal({
          showClose: false,
          vars: {
              body: $translate.instant('bm.header.previewMode.UnauthorizedBody'),
              title: $translate.instant('bm.header.previewMode.UnauthorizedTitle')
          },
          buttons: [
              { text: $translate.instant('bm.header.previewMode.OKButton'), value: 1, primary: true }
          ]
      });
    }

    function openViewProfileDialog(){
      if(ctrl.isPreviewModeEnabled) {
       notSupportPreviewModePopup();
       return false;
      }
      var modalOptions = {
        templateUrl: 'user-profile/view-profile-modal.2js.html',
        controller: 'bmViewProfileCtrl as vm',
        size: 'lg',
        backdrop: 'static',
        windowClass: 'bm-custom-profile-modal modal-dialog',
        resolve: {
          languages: function(){
            return [];
          },
          user: function(){
            return undefined;
          }
        }
      };

      var promises = [
        myAccountService.getLanguageListAsync(),
        myAccountService.getMyUserSettingsAsync()
      ];

      $rootScope.$emit('bm-busy-loading-on');
      $q.all(promises).then(function(results){
        $rootScope.$emit('bm-busy-loading-off');
        modalOptions.resolve = {
          languages: function(){
            return results[0];
          },
          user: function(){
            return results[1].data;
          }
        };

        openModalWithOptions(modalOptions);
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
        openModalWithOptions(modalOptions);
      });
    }

    function signOut(){
      toggleNavActive();
      closeDropdowns();
      authenticatedSession.destroy(signOutUrl);
    }

    function hasApps(){
      var frp = authenticatedSession.data.bindings.FeatureResourcePermissions;
      return frp ? Object.keys(frp.FeatureResourcePermissionsMap.Applications).length > 1 : false;
    }

    function clearNavActive(){
      $rootScope.$broadcast('bmca.nav.clearActive');
    }

    function toggleNavActive(){
      $rootScope.$broadcast('bmca.nav.toggleActive');
    }

    function closeDropdowns(){
      ctrl.isAppsDropdownOpen = false;
      ctrl.isHelpDropdownOpen = false;
      ctrl.isUserDropdownOpen = false;
      ctrl.isLinkedAccountDropdownOpen = false;
    }

    function openModalWithOptions(modalOptions){
      closeDropdowns();
      $uibModal.open(modalOptions);
    }

    // variation on http://stackoverflow.com/a/5624139
    function normalizeHex(hex){
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b){
          return r + r + g + g + b + b;
      });

      return hex.toLowerCase();
    }

    function hexToRgba(hex, a){
      hex = normalizeHex(hex);
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? 'rgba(' +
        parseInt(result[1], 16) + ',' +
        parseInt(result[2], 16) + ',' +
        parseInt(result[3], 16) + ',' +
        a + ')'
      : null;
    }

    function applyTheme(themeData){
      if(!themeData) { return; }

      // css overrides for theme
      var html = angular.element($document[0].documentElement);

      var colors = themeData.data.colors;
      if (!colors) { return; }

      var head = html.find('head'),
        headerFill = normalizeHex(colors.headerFillColor),
        headerText = normalizeHex(colors.headerTextColor),
        altHeaderFill = hexToRgba('#888888', 0.2),
        altHeaderText = (headerText === '#ffffff' ? '#ddd' : hexToRgba(headerText, 0.5)),
        buttonFill = normalizeHex(colors.buttonFillColor),
        buttonText = normalizeHex(colors.buttonTextColor),
        // todo: sanitize css values, move selectors to appropriate components?
        // try to template this as html
        style = angular.element([
          '<style>',
            '.btn.btn-primary {',
              'color:', buttonText, ' !important;',
              'background-color:', buttonFill, ' !important;',
              'border-color:', 'rgba(0,0,0,.2) !important', ';', // ?
            '}',
            '.btn.btn-primary:hover {',
              'border-color:', 'rgba(0,0,0,.4) !important', ';', // ?
            '}',
            '.nav-pills > li.active > a,',
            '.nav-pills > li > a:hover,',
            '.nav-pills > li > a:focus {',
              'color:', buttonFill, ' !important;',
            '}',
            'bm-client-app-nav ul a.bmca-header-active {',
              'border-color:', buttonFill, ' !important;',
            '}',
            'bm-client-app-header .global-header,',
            'bm-client-app-header .global-header .topbar-right {',
              'background-color:', headerFill, ';',
              'color:', headerText, ' !important;',
            '}',
            'bm-client-app-header .global-header .topbar-left .topbar-logo h1,',
            'bm-client-app-header .global-header .topbar-left .topbar-logo .topbar-brand {',
                'color:', headerText, ' !important;',
            '}',
            'bm-client-app-header .global-header .topbar-item > a,',
            'bm-client-app-header a.bmca-header-nav-toggle{',
              'color:', headerText, ';',
            '}',
            'bm-client-app-header .global-header .topbar-item > a:hover,',
            'bm-client-app-header .global-header .topbar-item > a:focus{',
              'color:', altHeaderText, ';',
            '}',
            'bm-client-app-header a.bmca-header-nav-toggle:hover,',
            'bm-client-app-header a.bmca-header-nav-toggle:focus,',
            '.bmca-mask-active bm-client-app-header a.bmca-header-nav-toggle{',
              'color:', altHeaderText, ';',
              'background:', altHeaderFill, ';',
            '}',
          '</style>'
        ].join(''));

      head.append(style);
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmClientAppNav', ['bm.component.templates', 'pascalprecht.translate', 'bluemoon.components.session', 'bmPermission']).component('bmClientAppNav', {
    templateUrl: 'components/client-nav/export/client-nav.html',
    bindings: {
      preview: '@'
    },
    controller: clientAppNav
  });

  clientAppNav.$inject = ['$window', '$document', '$location', '$rootScope', '$timeout', '$scope', '$element', 'AuthenticatedSessionData'];
  function clientAppNav($window, $document, $location, $rootScope, $timeout, $scope, $element, authenticatedSessionData){
    /*jshint validthis:true */
    var ctrl = this;
    var html = $document.find('html');
    var scope = $scope;

    ctrl.$onInit = onInit();
    ctrl.$postLink = postLink();

    ////////////////////

    function onInit() {
      ctrl.navActive = false;
      ctrl.isPreview = ctrl.preview === 'true';
      // ctrl.toggleNavActive = toggleNavActive;
      ctrl.clearNavActive = clearNavActive;
    }

    function postLink(){
      // listen for external clears
      var offNavClearActive = $rootScope.$on('bmca.nav.clearActive', ctrl.clearNavActive);

      // listen for external toggles
      var offNavToggleActive = $rootScope.$on('bmca.nav.toggleActive', toggleNavActive);

      // clear navActive on location change attempt
      var offLocChgStart = $rootScope.$on('$locationChangeStart', ctrl.clearNavActive);

      // perform window resize actions
      $window.addEventListener('resize', windowResized, false);

      // update active nav item on location change success
      var offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function(e, url){
        updateActiveNavItem($element.find('nav'), url);
      });

      // update active nav item after binding data is loaded and allowed nav items show
      authenticatedSessionData.getBindings().then(function(){
        // wait till next event loop
        $timeout(function(){
          updateActiveNavItem($element.find('nav'), $location.absUrl());
        });
      });

      // cleanup
      $element.on('$destroy', function(){
        offNavClearActive();
        offNavToggleActive();
        offLocChgStart();
        offLocChgSuccess();
        $window.removeEventListener('resize', windowResized, false);
      });
    }

    function toggleMaskActive(force){
      html.toggleClass('bmca-mask-active', force);
    }

    function toggleNavActive(){
      ctrl.navActive = !ctrl.navActive;
      toggleMaskActive(ctrl.navActive);
    }

    function clearNavActive(){
      if(ctrl.navActive){
        ctrl.navActive = false;
        toggleMaskActive(ctrl.navActive);
      }
    }

    function windowResized(){
      var applyNeeded = false;

      if(ctrl.navActive){
        ctrl.clearNavActive();
        applyNeeded = true;
      }

      if(applyNeeded){
        scope.$apply();
      }
    }

    // sync active nav item with location
    function updateActiveNavItem(nav, url){
      var i, candidates, candidate, candidateHrefNoQuery, matches, lastHrefChar, nextUrlChar, bestMatch;
      var urlNoQuery = url.split('?')[0];

      // clear all active
      nav.find('a').removeClass('bmca-header-active');

      // find match candidates
      candidates = nav.find('a');
      if(!candidates.length){ return; }

      // gather matches
      matches = [];

      for(i = 0; i < candidates.length; i++){
        candidate = candidates[i];
        if(!candidate.hasAttribute('href')){ continue; }

        // strip off query string
        candidateHrefNoQuery = candidate.href.split('?')[0];
        lastHrefChar = candidateHrefNoQuery.charAt(candidate.href.length - 1);
        nextUrlChar = urlNoQuery.charAt(candidateHrefNoQuery.length);

        if(urlNoQuery.indexOf(candidateHrefNoQuery) === 0 &&
          (lastHrefChar === '/' || !nextUrlChar.length || nextUrlChar === '/' || nextUrlChar === '?')){
          matches.push(candidate);
        }
      }

      // find best (longest) match
      for(i = 0; i < matches.length; i++){
        if(!bestMatch){
          bestMatch = matches[i];
        } else if (matches[i].href.length > bestMatch.href.length) {
          bestMatch = matches[i];
        }
      }

        // set best match active
      if(bestMatch){
        angular.element(bestMatch).addClass('bmca-header-active');
      }
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmClientAppMain', ['bm.component.templates']).component('bmClientAppMain', {
    templateUrl: 'components/client-main/export/client-main.html',
    transclude: true
  });
})(window.angular);

angular.module('bm.component.templates', ['components/client-header/export/client-header.html', 'components/client-main/export/client-main.html', 'components/client-nav/export/client-nav.html']);

angular.module("components/client-header/export/client-header.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-header/export/client-header.html",
    "<header class=\"global-header bm-shadow-z-1\" ng-click=\"$ctrl.clearNavActive()\">\n" +
    "  <!-- CCVNext Coming Soon Alert -->\n" +
    "  <div bento-alert bento-alert-object=\"ccVnextAlert\" bento-alert-close=\"$ctrl.closeCCVnextAlert()\"></div>\n" +
    "  <!-- Logo -->\n" +
    "  <div class=\"topbar-left\">\n" +
    "    <!-- hamburger nav toggle -->\n" +
    "    <!-- TODO: CHANGE THIS TO A TOOLTIP INSTEAD OF TITLE??? -->\n" +
    "    <a class=\"bmca-header-nav-toggle\" title=\"{{$ctrl.navMenuToggle}}\" ng-click=\"$ctrl.toggleNavActive();$event.stopPropagation()\"><i class=\"bento-icon-hamburger-menu\"></i></a>\n" +
    "    <!-- Logo name or Image -->\n" +
    "    <div class=\"topbar-item topbar-logo\">\n" +
    "      <h1 class=\"topbar-brand\">\n" +
    "        <img ng-if=\"$ctrl.theme.header.headerImage\" ng-src=\"{{ $ctrl.theme.header.headerImage }}\" /> <span ng-bind=\"$ctrl.theme.header.headerLine1\"></span>\n" +
    "      </h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "<!-- Preview Mode -->\n" +
    "  <div class=\"topbar-center\" ng-if=\"$ctrl.isPreviewModeEnabled\">\n" +
    "      <p>\n" +
    "        <span translate=\"bm.client.app.previewMode.youarein\"></span>\n" +
    "        <span class=\"orange\" translate=\"bm.client.app.previewMode.preview\"></span>\n" +
    "        <span translate=\"bm.client.app.previewMode.mode\"></span>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  <!-- Other CTAs -->\n" +
    "  <ul class=\"topbar-right\">\n" +
    "    <!-- Apps Menu -->\n" +
    "    <li id=\"bmca-header-apps-dropdown\" ng-if=\"$ctrl.hasApps()\" class=\"topbar-item\" uib-dropdown is-open=\"$ctrl.isAppsDropdownOpen\">\n" +
    "      <a ng-href=\"\" uib-tooltip=\"{{$ctrl.appsMenuToggle}}\" tooltip-placement=\"bottom\" uib-dropdown-toggle>\n" +
    "        <i class=\"bento-icon-grid\"></i>\n" +
    "        <i class=\"bento-icon-caret-down\"></i>\n" +
    "      </a>\n" +
    "      <div class=\"dropdown-menu account-menu\" role=\"menu\">\n" +
    "        <div class=\"account-menu-top\">\n" +
    "          <div class=\"account-menu-desc\">\n" +
    "            <div bm-if-perm=\"Applications.Onvio\">\n" +
    "              <a id=\"bmca-header-apps-staff-link\" href=\"/staff/\" target=\"_blank\" translate=\"bm.client.app.appsMenu.staffProductName\"></a>\n" +
    "            </div>\n" +
    "            <div bm-if-perm=\"Applications.OnvioClientHub\">\n" +
    "              <a id=\"bmca-header-apps-client-link\" href=\"/client/\" target=\"_blank\" translate=\"bm.client.app.appsMenu.clientProductName\"></a>\n" +
    "            </div>\n" +
    "            <div bm-if-perm=\"Applications.Workpapers\">\n" +
    "              <a id=\"bmca-header-apps-workpapers-link\" href=\"/workpapers/\" target=\"_blank\" translate=\"bm.client.app.appsMenu.workpapersProductName\"></a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <!-- Help Menu -->\n" +
    "    <li id=\"bmca-header-help-dropdown\" ng-if=\"!$ctrl.isPreview\" class=\"topbar-item\" uib-dropdown is-open=\"$ctrl.isHelpDropdownOpen\">\n" +
    "      <a ng-href=\"\" uib-tooltip=\"{{$ctrl.helpMenuToggle}}\" tooltip-placement=\"bottom\" uib-dropdown-toggle>\n" +
    "        <i class=\"bento-icon-question\"></i>\n" +
    "        <i class=\"bento-icon-caret-down\"></i>\n" +
    "      </a>\n" +
    "      <div class=\"dropdown-menu account-menu\" ng-controller=\"HelpCtrl\">\n" +
    "        <!-- Search field -->\n" +
    "        <div class=\"account-menu-top\">\n" +
    "          <div class=\"account-menu-desc\">\n" +
    "            <div ng-click=\"$event.stopPropagation()\">\n" +
    "              <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon\">\n" +
    "                 <span ng-click=\"helpSearch()\"><i class=\"bento-icon-search\"></i></span>\n" +
    "                </span>\n" +
    "                <label class=\"sr-only\" for=\"bm-header-help-search\" translate=\"bm.client.app.helpMenu.searchLabel\"></label>\n" +
    "                <input bento-reset type=\"text\" id=\"bm-header-help-search\" class=\"form-control\" ng-model=\"searchInput.text\" ng-keypress=\"searchKeyPress($event)\" placeholder=\"{{$ctrl.searchLabel}}\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"divider\"></div>\n" +
    "        <!-- Suggested Topics -->\n" +
    "        <div class=\"account-menu-top\">\n" +
    "          <div class=\"account-menu-desc\">\n" +
    "            <h4 translate=\"bm.client.app.helpMenu.topicsHeading\"></h4>\n" +
    "            <div ng-repeat=\"menu in help.topics\">\n" +
    "              <a ng-href=\"{{ formatTopicUrl(help, menu.url) }}\" target=\"_blank\">{{menu.title}}</a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"divider\"></div>\n" +
    "        <!-- Additional assistance -->\n" +
    "        <div class=\"account-menu-top\">\n" +
    "          <div class=\"account-menu-desc\">\n" +
    "            <h4 translate=\"bm.client.app.helpMenu.assistanceHeading\"></h4>\n" +
    "            <div ng-if=\"help && help.howToUrl\">\n" +
    "              <a ng-href=\"{{ howToLink() }}\" target=\"_blank\" translate=\"bm.client.app.helpMenu.siteLinkText\"></a>\n" +
    "            </div>\n" +
    "            <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <!-- End of Help Menu -->\n" +
    "    <!-- Begining of the linked accounts menu -->    \n" +
    "<!-- \n" +
    "    <li id=\"bmca-header-linked-account-dropdown\" ng-if=\"!$ctrl.isPreview\" class=\"topbar-item\" uib-dropdown \n" +
    "      is-open=\"$ctrl.isLinkedAccountDropdownOpen\" bm-if-has-access=\"PPE-AccountSwitching\">\n" +
    " -->\n" +
    "    <li id=\"bmca-header-linked-account-dropdown\" ng-if=\"$ctrl.showLinkedAccountsMenu\" class=\"topbar-item\" uib-dropdown is-open=\"$ctrl.isLinkedAccountDropdownOpen\">\n" +
    "      <!-- Menu name -->\n" +
    "      <a ng-href=\"\" title=\"{{$ctrl.selectedLinkedAccount.displayedName}}&#013{{$ctrl.selectedLinkedAccount.companyName}}\" uib-dropdown-toggle>\n" +
    "        <span class=\"topbar-multi-line\">\n" +
    "          <span class=\"topbar-multi-line-item\">{{$ctrl.selectedLinkedAccount.displayedName}}</span>\n" +
    "          <span class=\"topbar-multi-line-item\">{{$ctrl.selectedLinkedAccount.companyName}}</span>\n" +
    "        </span>\n" +
    "        <i ng-if=\"$ctrl.showLinkedAccountsMenu\" class=\"bento-icon-caret-down\"></i>\n" +
    "      </a>\n" +
    "\n" +
    "      <!-- Menu dropdown -->\n" +
    "      <div ng-if=\"$ctrl.showLinkedAccountsMenu\" class=\"dropdown-menu account-menu\" role=\"menu\">\n" +
    "        <!-- Manage Linked Accounts -->\n" +
    "        <div id=\"bmca-linked-account_menu_header\" class=\"account-menu-top\">        \n" +
    "          <div class=\"account-menu-section-header\">\n" +
    "            <span translate=\"bm.client.app.linkedAccountMenu.toggle\"></span>\n" +
    "            <span style=\"float: right\"><a class=\"linked-accounts-manager-link\" ng-click=\"$ctrl.openManageLinkedAccountsDialog()\" translate=\"bm.client.app.linkedAccountMenu.manage\"></a></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <!-- <div class=\"divider\"></div> -->\n" +
    "        <!-- List of available accounts -->\n" +
    "        <div id=\"bmca-linked-account_menu_item\" class=\"account-menu-item\">\n" +
    "          <div class=\"account-menu-desc\" ng-repeat=\"linkedAccount in $ctrl.linkedAccounts\" ng-click=\"$ctrl.switchAccount(linkedAccount.linkedAccountId)\">\n" +
    "            <div class=\"divider\"></div>\n" +
    "            <span class=\"account-menu-multi-line\" title=\"{{linkedAccount.displayedName}}&#013{{linkedAccount.companyName}}\">\n" +
    "              <a href=\"\">\n" +
    "              <span class=\"account-menu-multi-line-item\">{{linkedAccount.displayedName}}</span>\n" +
    "              <span class=\"account-menu-multi-line-item\">{{linkedAccount.companyName}}</span>          \n" +
    "              </a>\n" +
    "            </span>            \n" +
    "            <!-- <a ng-href=\"\">{{linkedAccount.accountName}}</a> -->\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>        \n" +
    "    <!-- End of linked accounts menu -->    \n" +
    "\n" +
    "    <!-- Profile Menu -->\n" +
    "    <li id=\"bmca-header-profile-dropdown\" ng-if=\"!$ctrl.isPreview\" class=\"topbar-item\" uib-dropdown is-open=\"$ctrl.isUserDropdownOpen\">\n" +
    "      <a ng-href=\"\" uib-tooltip=\"{{$ctrl.userMenuToggle}}\" tooltip-placement=\"bottom\" uib-dropdown-toggle>\n" +
    "        <i class=\"bento-icon-user\"></i>\n" +
    "        <i class=\"bento-icon-caret-down\"></i>\n" +
    "      </a>\n" +
    "      <div class=\"dropdown-menu account-menu\" role=\"menu\">\n" +
    "        <div class=\"account-menu-top\">\n" +
    "          <div class=\"account-menu-avatar\">\n" +
    "            <bm-profile-photo-select image=\"$ctrl.user.photo\" shape=\"circle\"></bm-profile-photo-select>\n" +
    "          </div>\n" +
    "          <div class=\"account-menu-desc\">\n" +
    "            <h4 id=\"bmca-header-user-name\" class=\"h2\" ng-bind=\"$ctrl.user.fullName\"></h4>\n" +
    "            <p id=\"bmca-header-profile-menu-email\" ng-bind=\"$ctrl.user.email\"></p>\n" +
    "            <div class=\"account-menu-actions\">\n" +
    "              <a id=\"bm-header-profile-link\" ng-click=\"$ctrl.openViewProfileDialog()\" translate=\"bm.client.app.userMenu.viewProfile\" ng-href=\"\"></a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"account-menu-foot\">\n" +
    "          <div>\n" +
    "            <span href=\"#\" class=\"btn btn-primary btn-sm\" translate=\"bm.client.app.userMenu.signOut\" ng-click=\"$ctrl.signOut()\">Sign out</span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <!-- End of Profile Menu -->\n" +
    "  </ul>\n" +
    "  <!-- End of topbar-right -->\n" +
    "</header>\n" +
    "");
}]);

angular.module("components/client-main/export/client-main.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-main/export/client-main.html",
    "<main class=\"bm-shadow-z-1\" ng-transclude></main>\n" +
    "");
}]);

angular.module("components/client-nav/export/client-nav.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-nav/export/client-nav.html",
    "<nav ng-class=\"{ 'bmca-header-active': $ctrl.navActive }\">\n" +
    "  <ul>\n" +
    "    <li bm-if-perm=\"TaxCenter.Tax\"><a href=\"/tax/center/#/\"><span class=\"bm-icon bm-icon-tax\"></span><span translate=\"bm.client.app.clientTaxModuleName\"></span></a></li>\n" +
    "    <li bm-if-perm=\"OnvioClientDrive.Drive\"><a href=\"/client/#/documents\"><span class=\"bm-icon bm-icon-documents\"></span><span translate=\"bm.client.app.dms.productName\"></span></a></li>\n" +
    "    <li ng-if=\"$ctrl.isPreview\"><a href=\"\"><span class=\"bm-icon bm-icon-tax\"></span><span translate=\"Onvio.Setup.Theme.Navigation.Tax\"></span></a></li>\n" +
    "    <li ng-if=\"$ctrl.isPreview\"><a href=\"\"><span class=\"bm-icon bm-icon-documents\"></span><span translate=\"bm.dms.productName\"></span></a></li>\n" +
    "  </ul>\n" +
    "</nav>\n" +
    "<div class=\"bmca-header-modal-mask\" ng-class=\"{ 'bmca-header-active': $ctrl.navActive }\" ng-click=\"$ctrl.clearNavActive()\"></div>\n" +
    "");
}]);
